import { ComponentsOverrides, Theme } from "@mui/material";
import { InternalThemeConfig } from "../../config";

const accordionSummary = ({ spacing }: InternalThemeConfig): ComponentsOverrides<Theme>["MuiAccordionSummary"] => {
	const rem16 = spacing(2);
	const rem24 = spacing(3);

	return {
		root: {
			minHeight: undefined,
			padding: `${rem16} ${rem24}`,
			"&.Mui-expanded": {
				minHeight: undefined,
			},
		},
		content: {
			margin: "0px",
			"&.Mui-expanded": {
				margin: "0px",
			},
		},
		// expandIcon: {
		// 	padding: 0,
		// 	margin: 0,
		// 	width: rem16,
		// },
	};
};

export default accordionSummary;
